import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  faqData: null,
};

export const getFaq = createAsyncThunk(
  "faq/getFaq",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`page/faqs`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);

    }
  }
);

const homeOurServiceSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {},
  extraReducers: {
    [getFaq.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getFaq.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.faqData = action.payload?.data;
    },
    [getFaq.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default homeOurServiceSlice.reducer;
